import { BinderAssembly } from "./binder-assembly.model"
import { UserData } from "./user-data.model";
import { BinderDeliverable } from "./binder-deliverable"
import { HsContact } from "./hs-contact"
import { ApprovalRequest } from "./approval.model"
import { BinderAccess } from "./binder-access.model"
import { BinderPromo, Promo } from "./promo.model"
import { Client, ClientNested } from "./client.model";
import { BinderDrafter, EngineerContact } from "./engineering-models.model";
import { Franchise } from "./franchise.model";
import { Draw, Lender } from "./bank-models.model";
import { Plan } from "./plan.model";
import { ProjectStatus } from "./project-status.model";
import { StandardOwnerItem } from "./standard-owner-item.model";
import { ExemptionReason } from "./exemption-reason.model";

export interface RequestResponse {
    viewAccess: boolean,
  editAccess: boolean,
  binderId:number,
  binder:Binder | null
}

export interface BinderTiny {
    BinderID: number;
    Longitude: string;
    Latitude: string;
    ClientLastName: string;
    DraftRequestDate: Date;
    ProjectStatus: number;
    Design_Fee: number;
    BinderTotal: number;
    PlanPrice: number;
    Prelim?: boolean;
    LastActive: Date;
    Users:{
        UID: number;
        DisplayName: string;
    };
    Franchises_Binders_SelectedFIDToFranchises: {
        FID: number;
        CityCode: string;
    };
    ProjectStatus_Binders_ProjectStatusToProjectStatus: {
        Status: string;
    };
    Clients?: {
        ClientLastName: string;
        Phone: string;
        Phone2: string;
        Phone3: string;
    };
    SiteAddress: string;
    SiteCity: string;

    Plans:  {
        PlanName: string;
        Thumb: string;
    }

}

export class BinderSmall implements BinderTiny {
    BinderID: number;
    Longitude: string;
    Latitude: string;
    ClientLastName: string;
    DraftRequestDate: Date;
    Design_Fee: number;
    BinderTotal: number;
    PlanPrice: number;
    Binders?: PrelimSmall;
    fromPrelim?: number;
    Thumb:string;
    UID: number;
    MainFID: number;
    County:string;
    SPID?: number;
    ClientID?: number;
    ProjectStatus: number;
    ScheduleID: number | null;
    JobNumber?: number;
    LastActive: Date;
    Activity: string;
    Created: Date;
    BinderReceivedDate: Date;
    FolderSPID?: number;
    SelectedFID: number;
    PlaceHolder: Boolean;
    DesignPrelimDueDate?: Date;
    DesignPrelimSendOffDate?: Date;
    nfcApproval?: Date;
    nfcDueForRedlines?: Date;
    nfcComplete?: Date;
    engineeringApproval?: Date;
    engineeringCompletion?: Date;
    planSetComplete?: Date;
    TrussSendOffDate?: Date;
    TrussReceivedDate?: Date;
    Processing_Fee: number;
    EngineeringFee: number;
    reUseFee: number;
    BilledToOffice: number;
    LastUserToEdit?: number;
    DraftStatus: string;
    Converted?: boolean;
    contractEx: boolean | null;
    exPending: boolean | null;
    draftStatus?: DraftStatus;
    SalesPrelimCompleteDate?: Date;
    SalesPrelimReceivedDate?: Date;
    BinderTimeline: BinderEvent[];
    draftStatusId: number | null;
    ModLevel?: number;
    PlanID: number;
    ES_Hash: string | null;
    Users:UserData
    Franchises_Binders_MainFIDToFranchises: Franchise;
    Franchises_Binders_SelectedFIDToFranchises: Franchise;
    ProjectStatus_Binders_ProjectStatusToProjectStatus: ProjectStatus;
    binderDrafters?: BinderDrafter[];
    Drafter?: number;
    Lenders?: Lender;
    Plans: Plan;
    TaxRate?: number;
    Tax_Location?:number;
    btRunningTotal: number;
    paidByOffice: number;
    LenderID?: number;
    Credit?: number;
    TaxOverride:boolean;
    CreditDesc?: string;
    Travel?: number;
    SiteState?: string;
    SiteZip?: number;
    SiteAddress: string;
    SiteCity: string;
    WindLoadASD?: number;
    WindLoadULT?: number;
    GroundSnowLoad?: number;
    RoofSnowLoad?: number;
    Seismic?: number;
    Exposure?: string;
    FrostDepth?: number;
    SoilPSF?: number;
    SitePlot?: string;
    Orientation?: string;
    binderDraftStatus?: BinderDraftStatus[];
    engineeringContacts?: EngineerContact;
    Prelim: boolean;
    SSID: number

    constructor(binderTiny?:BinderTiny | BinderRehydrated) {
        this.BinderID = binderTiny?.BinderID || 0;
        this.Converted = false;
        this.BinderTotal = 0;
        this.PlanPrice = 0;
        this.ScheduleID = null;
        this.ES_Hash = '';
        this.Thumb = '';
        this.Processing_Fee = 0;
        this.MainFID = 4;
        this.Longitude = '';
        this.Latitude = '';
        this.ClientLastName = binderTiny?.ClientLastName || '';
        this.County = '';
        this.ModLevel = 2;
        this.TaxOverride = false;
        this.ProjectStatus = 3;
        this.UID = 1;
        this.LastActive = new Date();
        this.Activity = 'Created';
        this.Created = new Date();
        this.BinderReceivedDate = new Date();
        this.DraftRequestDate = new Date();
        this.SelectedFID = 4;
        this.PlaceHolder = false;
        this.PlanID = 69;
        this.EngineeringFee = 0;
        this.contractEx = null;
        this.exPending = null;
        this.reUseFee = 0;
        this.BilledToOffice = 0;
        this.Design_Fee = 0;
        this.DraftStatus = 'Not Started';
        this.draftStatusId = 1;
        this.btRunningTotal = 0;
        this.paidByOffice = 0;
        this.SiteAddress = '';
        this.SiteCity = '';
        this.Users = new UserData();
        this.SSID = 0;
        this.Lenders = {
            Title: "",
            FID: 0,
            LenderID: 0
        };
        this.Plans = new Plan;
        this.BinderTimeline = [];
        this.Franchises_Binders_MainFIDToFranchises = new Franchise;
        this.Franchises_Binders_SelectedFIDToFranchises = new Franchise;
        this.ProjectStatus_Binders_ProjectStatusToProjectStatus = {
            Status: '',
            StatusID: 0,
            DraftingStatus: false
        };
        this.Orientation = '';
        this.Prelim = false;
    }
    getJobName(): string {
        return this.JobNumber ? this.JobNumber.toString() : '';
    }
    getLatestDateForEventType(eventTypeId: string) {
        let num = Number(eventTypeId)
        if (!this.BinderTimeline) return null;
        const filteredEvents = this.BinderTimeline.filter(event => event.eventTypeId === num && event.eventDate);
        const latestEvent = filteredEvents.reduce((latest, current) => {
          return new Date(latest.eventDate) > new Date(current.eventDate) ? latest : current;
        }, filteredEvents[0]);
        return latestEvent ? latestEvent.eventDate : null;
      }
    getModSeverity(modId: number) {
        if (modId = 2) {
            return 'primary';
          } else if (modId = 3) {
            return 'success';
          } else if (modId = 4) {
            return 'warning';
          } else if (modId = 5) {
            return 'danger';
          } else {
            return 'secondary';
          }
    }
}

export interface BinderMinimal {
    BinderID: number;
    ClientLastName: string;
    JobNumber?: number;
    LastActive: Date;
    SiteState?: string;
    SiteZip?: number;
    SiteAddress: string;
    SiteCity: string;
    BinderTotal: number;
    Design_Fee: number;
    Plans: {
            PlanName: string;
            Thumb: string;
    }
}

export class Binder extends BinderSmall {
    Title?: string;
    Clients?: ClientNested;
    binderPromos?: BinderPromo[];
    ShowTravel?:boolean;
    haId: string | null;
    haBuilderId: string | null;
    StateID?: number;
    BinderAssemblies: BinderAssembly[];
    OwnerItems?: OwnerItem[];
    feeOverride?: number | null;
    Schedules?: {
        Title:string,
      LenderID: number,
      FID: number,
      ScheduleID: number,
      isCash: boolean;
      OldScheduleID: number,
      Deleted: boolean;
      Draws: Draw[]
    };
    addEngineering: number | null;
    contacts?: HsContact[];
    BinderDeliverables: BinderDeliverable[];
    approvalRequests: ApprovalRequest[];
    items?:any[];
    BinderAccess?: BinderAccess[];
    exemptionReasons?: ExemptionReason[];
    powerCo: string;
    waterSupply: string;
    septicDesigned: boolean;
    preapprovedAmount: number;
    wetlands: boolean;
    powerLoc: string;
    septic: boolean;
    FeePercentage?: number;
    windType: string | null;
    windload: number | null;
    snowType: string | null;
    snowload: number | null;
    PropertyValue: number;
    enableExtraTemplates: boolean | null;

    constructor(binder?:Partial<Binder>) {
        super();
        this.BinderID = binder?.BinderID || 0;
        this.Converted = binder?.Converted || false;
        this.addEngineering = binder?.addEngineering || null;
        this.BinderTotal = binder?.BinderTotal || 0;
        this.PlanPrice = binder?.PlanPrice || 0;
        this.ES_Hash = binder?.ES_Hash || '';
        this.Thumb = binder?.Thumb || '';
        this.Processing_Fee = binder?.Processing_Fee || 0;
        this.MainFID = binder?.MainFID || 4;
        this.Longitude = binder?.Longitude || '';
        this.Latitude = binder?.Latitude || '';
        this.ClientLastName = binder?.ClientLastName || ''  ;
        this.ScheduleID = binder?.ScheduleID || null;
        this.approvalRequests = binder?.approvalRequests || [];
        this.County = binder?.County || '';
        this.ModLevel = binder?.ModLevel || 2;
        this.TaxOverride = binder?.TaxOverride || false;
        this.ProjectStatus = binder?.ProjectStatus || 3;
        this.UID = binder?.UID || 1;
        this.haId = binder?.haId || null;
        this.haBuilderId = binder?.haBuilderId || null;
        this.LastActive = binder?.LastActive || new Date();
        this.Activity = binder?.Activity || 'Created';
        this.Created = binder?.Created || new Date();
        this.BinderReceivedDate = binder?.BinderReceivedDate || new Date();
        this.DraftRequestDate = new Date();
        this.SelectedFID = binder?.SelectedFID || 4;
        this.PlaceHolder = binder?.PlaceHolder || false;
        this.PlanID = binder?.PlanID || 69;
        this.EngineeringFee = binder?.EngineeringFee || 0;
        this.contractEx = binder?.contractEx || null;
        this.exPending = binder?.exPending || null;
        this.reUseFee = binder?.reUseFee || 0;
        this.BilledToOffice = binder?.BilledToOffice || 0;
        this.Design_Fee = binder?.Design_Fee || 0;
        this.DraftStatus = binder?.DraftStatus || 'Not Started';
        this.draftStatusId = binder?.draftStatusId || 1;
        this.btRunningTotal = binder?.btRunningTotal || 0;
        this.paidByOffice = binder?.paidByOffice || 0;
        this.BinderAssemblies = binder?.BinderAssemblies || [];
        this.BinderDeliverables = binder?.BinderDeliverables || [];
        this.Users = binder?.Users || new UserData();
        this.PropertyValue = binder?.PropertyValue || 0;
        this.Lenders = binder?.Lenders || {
            Title: "",
            FID: 0,
            LenderID: 0
        };
        this.Plans = binder?.Plans || new Plan;
        this.BinderTimeline = binder?.BinderTimeline || [];
        this.Franchises_Binders_MainFIDToFranchises = binder?.Franchises_Binders_MainFIDToFranchises || new Franchise;
        this.Franchises_Binders_SelectedFIDToFranchises = binder?.Franchises_Binders_SelectedFIDToFranchises || new Franchise;
        this.ProjectStatus_Binders_ProjectStatusToProjectStatus = binder?.ProjectStatus_Binders_ProjectStatusToProjectStatus || {
            Status: '',
            StatusID: 0,
            DraftingStatus: false
        };
        this.Orientation = binder?.Orientation || '';
        this.Prelim = binder?.Prelim || false;
        this.powerCo = binder?.powerCo || '';
        this.waterSupply = binder?.waterSupply || '';
        this.septicDesigned = binder?.septicDesigned || false;
        this.preapprovedAmount = binder?.preapprovedAmount || 0;
        this.wetlands = binder?.wetlands || false;
        this.powerLoc = binder?.powerLoc || '';
        this.septic = binder?.septic || false;
        this.windType = binder?.windType || null;
        this.windload = binder?.windload || null;
        this.snowType = binder?.snowType || null;
        this.snowload = binder?.snowload || null;
        this.enableExtraTemplates = binder?.enableExtraTemplates || false;
    }
}

export interface BinderRehydrated extends BinderCompact {
  Thumb:string;
  UID: number;
  Binders: PrelimSmall;
  fromPrelim: number;
  MainFID: number;
  Longitude: string;
  Latitude: string;
  ClientLastName: string;
  County:string;
  SPID: number;
  ClientID: number;
  ProjectStatus: number;
  JobNumber: number;
  LastActive: Date;
  ScheduleID: number | null;
  ModID: number;
  Activity: string;
  Created: Date;
  BinderReceivedDate: Date;
  DraftRequestDate: Date;
  FolderSPID: number;
  SelectedFID: number;
  PlaceHolder: Boolean;
  status: string;
  CityCode: string;
  DesignPrelimDueDate: Date;
  DesignPrelimSendOffDate: Date;
  nfcApproval: Date;
  nfcDueForRedlines: Date;
  nfcComplete: Date;
  engineeringApproval: Date;
  engineeringCompletion: Date;
  planSetComplete: Date;
  TrussSendOffDate: Date;
  TrussReceivedDate: Date;
  Processing_Fee: number;
  Engineer: string;
  EngineeringFee: number;
  reUseFee: number;
  BilledToOffice: number;
  LastUserToEdit: number;
  DraftStatus: string;
  contractEx: boolean | null;
  exPending: boolean | null;
  Design_Fee: number;
  draftStatus?: DraftStatus;
  SalesPrelimCompleteDate: Date;
  SalesPrelimReceivedDate: Date;
  BinderTimeline: BinderEvent[];
  draftStatusId: number | null;
  TaxOverride: boolean;
  ModLevel?: number;
  PlanID: number;
  ES_Hash: string;
  Users:UserData
  Franchises_Binders_MainFIDToFranchises: Franchise;
  Franchises_Binders_SelectedFIDToFranchises: Franchise;
  ProjectStatus_Binders_ProjectStatusToProjectStatus: ProjectStatus;
  Users_Binders_DrafterToUsers: {
      DisplayName: string,
      UID: number;
  };
  BinderNotes?: BinderNote[]
  Drafter?: number;
  Lenders?: Lender;
  Plans: Plan;
  TaxRate?: number;
  btRunningTotal: number;
  paidByOffice: number;
  ProcessingFee?: number;
  BinderTotal?: number;
  LenderID?: number;
  PlanPrice?: number;
  Credit?: number;
  CreditDesc?: string;
  TravelFee?: number;
  SiteState?: string;
  SiteZip?: number;
  WindLoadASD?: number;
  WindLoadULT?: number;
  GroundSnowLoad?: number;
  RoofSnowLoad?: number;
  Seismic?: number;
  Exposure?: string;
  FrostDepth?: number;
  SoilPSF?: number;
  SitePlot?: string;
  Orientation?: string;
  binderDraftStatus?: BinderDraftStatus[];
}

export interface BinderNote {
    BinderID: number,
    ClientID: number,
    Note: string,
    CreatedOn: Date,
    UID: number,
    UserName: string,
    BNoteID: number,
    Modified: Date,
    ModUID: number,
    ModUserName: string,
    Subject: string,
    BinderNote: boolean,
    DraftOnly: boolean,
    DraftingNote: boolean,
    FileLink: string,
    EventID: number,
    HotNote: boolean,
    LassoNoteID: string,
    EntryID: number,
    CaseID: number | null,
    binderCaseId: number | null,
}

export interface BinderCompact {
  BinderID: number,
  Prelim: boolean,
  ClientLastName: string,
  Clients: {
      ClientLastName: string,
      Phone: string,
      Phone2: string,
      Phone3: string,
      Email: string,
      Email2: string,
      Email3: string,
  },
  SiteAddress: string,
  SiteCity: string,
  Plans: {
      PlanName: string
  },
  ProjectStatus_Binders_ProjectStatusToProjectStatus: {
      Status: string,
      StatusID: number
  },
  Franchises_Binders_SelectedFIDToFranchises: {
      CityCode: string
  },
  Users: {
      DisplayName: string
  },
  binderDraftStatus?:
      {
          DraftStatus: {
              statusName: string
          }
      }[],
  BinderTimeline: 
      {
          EventTypes: {
              eventName: string
          },
          eventDate: Date
      }[],
  Users_Binders_DrafterToUsers?: {
      DisplayName: string
  },
  LastActive: Date
}

export interface BinderDetails {
    assemblies : BinderAssembly[],
    schedules: {
        Title:string,
      LenderID: number,
      FID: number,
      ScheduleID: number,
      isCash: boolean;
      OldScheduleID: number,
      Deleted: boolean;
      Draws: Draw[]
    }
    parsedClients: Client[],
    deliverables: BinderDeliverable[],
    approvalRequests: ApprovalRequest[]
}

export interface OwnerItem {
    BinderID: number;
    Item: string;
    ItemOrder: number;
  Priceint: number;
  ItemID: number;
  SOID: number | null;
  Responsibility: number | null;
  StandardOwnerItems?: StandardOwnerItem | null;
}

export interface BinderTag {
  name: string;
  icon: string;
  type: 'projectStatus' | 'exemption' | 'higharc';
  color: "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined;
}

export interface PrelimSmall {
    ClientLastName: string;
    BinderID: number;
    binderDraftStatus?: BinderDraftStatus[];
}

export interface BinderDraftStatus {
    binderId: number,
    draftStatusId: number,
    binderDraftStatusId: number,
    DraftStatus: DraftStatus
}

export interface DraftStatus {
    statusName: string,
    orderNumber: number,
    projectStatusID: number,
    draftStatusId: number
}

export class BinderEvent {
  eventDate: Date;
  BinderID: number;
  eventTypeId: number;
  createdBy: number;
  binderEventId: number;
  createdOn: Date;
  Users?: UserData;
  EventTypes: EventType;
  summary: string;

  constructor() {
      this.eventDate = new Date();
      this.BinderID = 0;
      this.eventTypeId = 1;
      this.createdBy = 1;
      this.binderEventId = 0;
      this.createdOn = new Date();
      this.EventTypes = {
          eventName: 'Binder Ordered',
          eventTypeId: 1
      }
      this.summary = '';
  }
}

export interface EventType {
  eventName: string,
  eventTypeId: number,
  archived?: boolean,
  draftStatusId?: number,
  ProjectStatusID?: number,
  SPID?: number,
  note?: string,
  attUID?: number,
  icon?: string,
  color?: string,
}